// @flow
import { API } from 'api/api'
import { makeGetRequest } from 'api/fetchCalls'
import type { Form } from 'types/form'
import type { Packet } from 'types/packet'

export async function getResource(uid: string): Promise<Form | Packet> {
  return makeGetRequest(API.RESOURCE.GET_RESOURCE(uid))
}

export const KEEP_ME = true
